import { TERMS } from "@netkeep/legal";
import { LegalDocumentView } from "@/components/LegalDocumentView";

export default function TermsPage() {
  return <LegalDocumentView doc={TERMS} />;
}
